module.exports = __webpack_public_path__ + "static/img/caseImg6.39ddd49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseImg6.jpg
// module id = IIXr
// module chunks = 0